(() => {
  const config=document.querySelector('[data-cto-exact-config]');
  const core=window.CTOReferenceCore;
  if(!config || !core) return;
  const pending=new WeakSet();
  let indexPromise;
  let navigationVersion=0;
  const preview=new URL(location.href).searchParams.get('preview_theme_id') || config.dataset.preview;
  const root=config.dataset.root.replace(/\/$/,'');
  const decorate=url=>{if(preview)url.searchParams.set('preview_theme_id',preview);return url;};
  const searchUrl=query=>{
    const url=decorate(new URL(config.dataset.results,location.origin));
    url.searchParams.set('q',query);
    return url.href;
  };
  async function timedFetch(url) {
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),5000);
    try {const r=await fetch(url,{signal:controller.signal,credentials:'same-origin'});if(!r.ok)throw Error('Unavailable');return await r.text();}
    finally {clearTimeout(timer);}
  }
  async function index() {
    if(!indexPromise) {
      indexPromise=timedFetch(config.dataset.index).then(text=>{
        const data=JSON.parse(text);
        if(data.version!==1 || !Array.isArray(data.records))throw Error('Invalid index');
        return core.build(data.records);
      });
      indexPromise.catch(()=>{indexPromise=null;});
    }
    return indexPromise;
  }
  async function resolve(query) {
    if(!query || query.length>100) return null;
    if(/\s/.test(query.trim()) && !/\d/.test(query))return null;
    let match;
    try {
      const maps=await index();match=core.exact(maps,query);
      const key=core.normalize(query),upc=core.barcode(query);
      if(!match && (maps.sku.has(key)||maps.mpn.has(key)||(upc&&maps.barcode.has(upc))))return null;
    }catch{}
    if(match) {
      const verify=decorate(new URL(`${root}/products/${encodeURIComponent(match.handle)}`,location.origin));
      verify.searchParams.set('view','cto-identifiers');
      try {
        const doc=new DOMParser().parseFromString(await timedFetch(verify),'text/html');
        const current=JSON.parse(doc.querySelector('[data-cto-identifiers]')?.textContent || '{}');
        const verified=core.exact(core.build(current.records || []),query);
        if(!verified) return null;
        const url=decorate(new URL(current.url,location.origin));
        if(url.origin!==location.origin || !url.pathname.includes('/products/'))return null;
        if(verified.variant)url.searchParams.set('variant',verified.variant);
        return url.href;
      }catch{return null;}
    }
    if(!/\d/.test(query) || !(/^[\p{L}\p{N}._\/-]+$/u.test(query) || core.barcode(query)))return null;
    try {
      const url=decorate(new URL(config.dataset.search,location.origin));
      url.searchParams.set('q',query);url.searchParams.set('type','product');url.searchParams.set('view','cto-exact');
      const doc=new DOMParser().parseFromString(await timedFetch(url),'text/html');
      const data=JSON.parse(doc.querySelector('[data-cto-exact-data]')?.textContent || '{}');
      if(!data.complete)return null;
      const result=core.exact(core.build(data.records || []),query);
      if(!result)return null;
      const dest=decorate(new URL(`${root}/products/${encodeURIComponent(result.handle)}`,location.origin));
      if(result.variant)dest.searchParams.set('variant',result.variant);
      return dest.href;
    }catch{return null;}
  }
  function searchInput(node) {
    return node instanceof Element && node.matches('input[name="q"],input[data-cto-reference-input],#snize-mobile-search-input,#snize-input') ? node : null;
  }
  async function go(input,form) {
    if(pending.has(input))return;
    const query=input.value.trim();if(!query)return;
    const version=++navigationVersion;
    pending.add(input);input.setAttribute('aria-busy','true');
    form?.setAttribute('aria-busy','true');
    const target=await resolve(query);
    pending.delete(input);input.removeAttribute('aria-busy');form?.removeAttribute('aria-busy');
    if(version===navigationVersion)location.assign(target || searchUrl(query));
  }
  window.CTOExactSearch={resolve,searchUrl};
  window.addEventListener('input',e=>{if(e.isTrusted && searchInput(e.target))navigationVersion++;},true);
  window.addEventListener('focusin',e=>{if(searchInput(e.target))index().catch(()=>{});},true);
  window.addEventListener('keydown',e=>{
    if(e.key!=='Enter' || e.isComposing || e.ctrlKey || e.metaKey || e.altKey)return;
    const input=searchInput(e.target);if(!input || !input.value.trim())return;
    e.preventDefault();e.stopImmediatePropagation();go(input,input.closest('form'));
  },true);
  window.addEventListener('submit',e=>{
    const form=e.target;
    if(!(form instanceof HTMLFormElement))return;
    const input=form.querySelector('input[name="q"],input[data-cto-reference-input]');
    if(!input || !input.value.trim())return;
    const action=new URL(form.action || location.href,location.origin);
    if(!form.matches('[role="search"],.search-bar') && !/\/search/.test(action.pathname))return;
    e.preventDefault();e.stopImmediatePropagation();go(input,form);
  },true);
})();
